import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AppService {
    constructor(private apiService: ApiService) { }

    create(app, appid) {
        return this.apiService.post('/app', app).map(data => data);
    }

    getListOfApp(filterType) {

        if(!filterType){
            filterType = 0;
        }
        return this.apiService.get('/applist/' + filterType).map(data => data);
    }

    getAppById(id) {
        return this.apiService.get('/app/' + id).map(data => data);
    }

    getAppSettingsById(id) {
        return this.apiService.get('/appsettings/' + id).map(data => data);
    }

    delete(id) {
        return this.apiService.delete('/app/' + id).map(data => data);
    }
    getAllAppCategoryList() {
        return this.apiService.get('/appcategoryidnamelist').map(data => data);
    }
    getListOfCompany() {
        return this.apiService.get('/companylist').map(data => data);
    }

    getAppListByUserId(id) {
        return this.apiService.get('/applistbyuser/' + id).map(data => data);
    }

    GetAllAppList() {
        var appid = 0;
        if(window.sessionStorage['selectedApp'] != null && window.sessionStorage['selectedApp'] != 'undefined'){
            appid = JSON.parse(window.sessionStorage['selectedApp']);
        }        
        return this.apiService.get('/appidnamelist/'+appid['Id']).map(data => data);
    }

    getAgreement(id) {
        return this.apiService.get("/agreementbyappid/" + id).map(data => data);
    }

    saveAgreement(agreement) {
        return this.apiService.post("/agreement", agreement).map(data => data);
    }

    getAppTimeZoneById(id){        
        return this.apiService.get("/timezonebyappid/"+id).map(data => data);
    }

    checkAgreement(appId, appName){
        return this.apiService.get('/useragreementstatus/'+appId).map(data => data);        
    }

    getTimeZoneList(Id){
        return this.apiService.get('/gettimezonelist/'+Id).map(data => data);
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/app-management/app-management.ts